import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/pintura-y-acabados-complete-service-page/page.tsx");
